var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 6.66667C15 9.6775 11.7758 12.8575 10.5058 13.9958C10.3606 14.1068 10.1828 14.1669 10 14.1669C9.81719 14.1669 9.63945 14.1068 9.49417 13.9958C8.225 12.8575 5 9.6775 5 6.66667C5 5.34058 5.52678 4.06881 6.46447 3.13113C7.40215 2.19345 8.67392 1.66667 10 1.66667C11.3261 1.66667 12.5979 2.19345 13.5355 3.13113C14.4732 4.06881 15 5.34058 15 6.66667Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6667 6.66667C11.6667 7.58714 10.9205 8.33333 10 8.33333C9.07953 8.33333 8.33333 7.58714 8.33333 6.66667C8.33333 5.74619 9.07953 5 10 5C10.9205 5 11.6667 5.74619 11.6667 6.66667Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.26172 11.6667H4.17005C3.99533 11.6667 3.82504 11.7217 3.68328 11.8239C3.54152 11.926 3.43544 12.0701 3.38005 12.2358L1.71005 17.2358C1.66819 17.3611 1.65669 17.4945 1.67651 17.6251C1.69634 17.7557 1.74691 17.8797 1.82407 17.9868C1.90123 18.094 2.00276 18.1813 2.12029 18.2416C2.23782 18.3018 2.36798 18.3333 2.50005 18.3333H17.5001C17.632 18.3332 17.7621 18.3018 17.8795 18.2416C17.997 18.1814 18.0984 18.0942 18.1756 17.9871C18.2527 17.88 18.3033 17.7561 18.3232 17.6257C18.3431 17.4952 18.3318 17.3619 18.2901 17.2367L16.6234 12.2367C16.5681 12.0707 16.462 11.9263 16.32 11.824C16.1781 11.7217 16.0075 11.6666 15.8326 11.6667H12.7392",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationDark);
export default __webpack_public_path__ + "static/media/icon-location-dark.87d886d7a40e7300dfbba492a1d897f7.svg";
export { ForwardRef as ReactComponent };